import { AlertTriangle, Inbox, LoaderCircle, RotateCcw } from 'lucide-react'

export function LoadingState({ label = 'Loading…', fullPage = false }: { label?: string; fullPage?: boolean }) {
  return <div className={fullPage ? 'state-view full-page' : 'state-view'}><LoaderCircle className="spin" size={25} /><span>{label}</span></div>
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  const message = error instanceof Error ? error.message : 'Something went wrong.'
  return <div className="state-view error-state"><AlertTriangle size={25} /><strong>Unable to load records</strong><span>{message}</span>{retry && <button className="secondary-button" type="button" onClick={retry}><RotateCcw size={15} /> Try again</button>}</div>
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return <div className="state-view"><Inbox size={28} /><strong>{title}</strong><span>{description}</span></div>
}
